var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"ps-flex ps-items-center ps-justify-center ps-no-underline",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('tab-click', _vm.slug)}}},[_vm._t("default"),_vm._t("after")],2)}
var staticRenderFns = []

export { render, staticRenderFns }